import docReady from './Functions/docReady'

function isHidden(el) {
    var style = window.getComputedStyle(el);
    return (style.display === 'none')
}

const acceptTermsElement = document.querySelector('#accept-terms input');

function redirectToAuthProvider(element) {
    if (acceptTermsElement.checked) {
        window.location.href = element.currentTarget.getAttribute('data-href');
    }
    else {
        let message = document.querySelector('span[data-valmsg-for="AcceptTerms"]');
        acceptTermsElement.classList.add('input-validation-error');
        message.innerText = acceptTermsElement.getAttribute('data-val-required-custom');
        message.classList.remove('field-validation-valid');
        message.classList.add('field-validation-error');
    }
}

function initialiseSignupPage() {
    if (acceptTermsElement) {
        document.querySelectorAll('.pic-auth-provider').forEach(item => {
            item.setAttribute('data-href', item.href);
            item.href = 'javascript: void(0)';
            item.addEventListener('click', redirectToAuthProvider);
        })
    }
}

docReady(function () {
    document.querySelectorAll('.js-forgotten-password-toggle').forEach(item => {
        item.addEventListener('click', event => {
            event.stopPropagation();
            let authFields = document.querySelector('.js-auth-fields');
            let resetPassFields = document.querySelector('.js-reset-password-fields');
            if (isHidden(authFields)) {
                authFields.style.display = 'block';
                resetPassFields.style.display = 'none';
                document.getElementById('Password').disabled = false;
            }
            else {
                authFields.style.display = 'none';
                resetPassFields.style.display = 'block';
                document.getElementById('Password').value = '';
                document.getElementById('Password').disabled = true;
                document.getElementById('Username').focus();
            }
        })
    })

    initialiseSignupPage();

//    document.getElementById('Username').addEventListener('keydown', event => {
//        if (event.keyCode === 13) {
//            event.preventDefault();
//            buttonNext.click();
//            return;
//        }
//    })
});
